import React, { useEffect } from "react";
import { JobForm } from "./Forms/JobForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneJobQuery,
  useUpdateJobMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditJob = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const {
    data: jobResponse,
    isLoading,
    isFetching,
  } = useGetOneJobQuery({ id });
  const job = jobResponse?.data?.data;
  const loading = isLoading || isFetching;

  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateJob, isPending } = useUpdateJobMutation(setError);

  const onSubmit = (data) => {
    updateJob({ ...data, id });
  };

  useEffect(() => {
    if (job) {
      reset(job);
    }
  }, [job, reset]);

  return (
    <Stack gap={2}>
      <PageHeader title={t("EDIT_JOB")} />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <JobForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_JOB")}
                  </>
                ) : (
                  t("UPDATE_JOB")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};
